module.exports = __webpack_public_path__ + "static/media/sport.a3448600.svg";